import { gql } from "@apollo/client";

export const GET_SETUP_DATA = gql`
query GetProvidersSetupData($providersSetupInput: ProvidersSetupInput!) {
  getProvidersSetupData(providersSetupInput: $providersSetupInput) {
    campaignName
    removeDuplicate
    senderEmail
    senderName
    senderNumber
    stopMessage
  }
}
`